// extracted by mini-css-extract-plugin
export default {"dropzone":"FilePicker_dropzone__6bf1j"};